module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-container",
    attrs: {
      "id": "ql-login-screen"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-vertical-align": "center"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "30",
      "md-flex-offset": "35",
      "md-align": "center"
    }
  }, [_c('h1', [_c('img', {
    attrs: {
      "src": require('../assets/img/cuelistBLACK.png'),
      "alt": "LOGO"
    }
  })])]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "100",
      "md-align": "center"
    }
  }, [(_vm.signingIn) ? _c('md-button', {
    staticClass: "md-raised md-primary",
    on: {
      "click": _vm.login
    }
  }, [_c('md-icon', [_vm._v("person")]), _vm._v(" Sign in with Google")], 1) : _c('md-button', {
    staticClass: "md-raised md-primary",
    on: {
      "click": _vm.login
    }
  }, [_c('md-icon', [_vm._v("person")]), _vm._v(" Register with Google")], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30",
      "md-flex-offset": "35",
      "md-align": "center"
    }
  }, [_c('h1', {
    staticClass: "md-body-1"
  }, [_vm._v("Or")]), _vm._v(" "), (_vm.signingIn) ? _c('md-layout', {
    attrs: {
      "md-flex": "100",
      "md-align": "center"
    }
  }, [_c('h1', {
    staticClass: "md-title"
  }, [_vm._v("Sign in with your email")]), _vm._v(" "), _c('login-form'), _vm._v(" "), _c('md-button', {
    on: {
      "click": _vm.toggleRegister
    }
  }, [_vm._v("Need to Register instead?")])], 1) : _c('md-layout', {
    attrs: {
      "md-flex": "100",
      "md-align": "center"
    }
  }, [_c('h1', {
    staticClass: "md-title"
  }, [_vm._v("Register with your email")]), _vm._v(" "), _c('register-form', {
    on: {
      "success": _vm.createUser
    }
  }), _vm._v(" "), _c('md-button', {
    on: {
      "click": _vm.toggleRegister
    }
  }, [_vm._v("Need to Sign In instead?")])], 1)], 1)], 1), _vm._v(" "), _c('core-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-634848df","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sample/views/login.vue
// module id = 656
// module chunks = 2